import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useTranslation } from "react-i18next";

import { createDraftShiftAsync } from "../../../../../../export/scheduler";
import { JOB, SKILLS } from "../../../../../assets/constants";
import Button from "../../../../../design/button";
import useHolidayConflictRetry from "../../../../holidays/controller/use-holiday-conflict-retry";
import useCopyShiftHolidays from "./controllers/use-copy-shift-holidays";
import { CopyShiftsDataBySkillsProps, CopyShiftsDataProps } from "./types";

interface ActionButtonsProps {
	handleClose: () => void;
	copiedShiftData: CopyShiftsDataProps[];
	copiedShiftDataBySkills: CopyShiftsDataBySkillsProps[];
	shiftsByFilter: string;
	createDraftShiftAsyncStatus: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
	handleClose,
	copiedShiftData,
	copiedShiftDataBySkills,
	shiftsByFilter,
	createDraftShiftAsyncStatus,
}) => {
	const { t } = useTranslation();
	const submitWithHolidayConfirmation = useHolidayConflictRetry();
	const activeShiftData: (CopyShiftsDataProps | CopyShiftsDataBySkillsProps)[] =
		shiftsByFilter === SKILLS ? copiedShiftDataBySkills : copiedShiftData;
	const holidayByShiftId = useCopyShiftHolidays(activeShiftData);

	const handleCopy = () => {
		if (shiftsByFilter !== JOB && shiftsByFilter !== SKILLS) return;
		// Shifts the holiday banner warned about are sent as confirmed
		const data = activeShiftData.map((shift) => ({
			...shift,
			isOnHoliday: holidayByShiftId.has(shift.id),
		}));
		submitWithHolidayConfirmation((confirmedIndexes) =>
			createDraftShiftAsync({
				copiedShiftData: data,
				copiedOn: true,
				confirmedIndexes,
			})
		);
	};

	const disabled =
		(shiftsByFilter === JOB && copiedShiftData.length === 0) ||
		(shiftsByFilter === SKILLS && copiedShiftDataBySkills.length === 0) ||
		createDraftShiftAsyncStatus === "pending";
	return (
		<Box
			display='flex'
			width='100%'
			justifyContent='flex-end'
			alignItems='center'
		>
			{" "}
			<Box ml={2} display='flex' justifyContent='space-between' width='220px'>
				<Button color='primary' variant='text' onClick={handleClose}>
					{t("common_cancel")}
				</Button>
				{/* <LoadingButton
					loading={createDraftShiftAsyncStatus === "pending"}
					variant='contained'
					color='primary'
					type='submit'
					disabled={disabled}
					onClick={() => {
						let data: CopyShiftsDataProps[] | CopyShiftsDataBySkillsProps[] =
							[];
						if (shiftsByFilter === JOB) {
							data = copiedShiftData;
						} else if (shiftsByFilter === SKILLS) {
							data = copiedShiftDataBySkills;
						}
						dispatch(
							createDraftShiftAsync({ copiedShiftData: data, copiedOn: true })
						);
					}}
					sx={{ letterSpacing: "0.02857em" }}
				>
					Copy Shifts
				</LoadingButton> */}
				<Button
					color='primary'
					type='submit'
					disabled={disabled}
					onClick={handleCopy}
				>
					{createDraftShiftAsyncStatus === "pending" ? (
						<div style={{ position: "relative" }}>
							<CircularProgress
								size={25}
								style={{ position: "absolute", left: "50%" }}
							/>{" "}
							{t("scheduler_copying-shifts")}
						</div>
					) : (
						t("scheduler_copy-shifts")
					)}
				</Button>
			</Box>
		</Box>
	);
};

export default ActionButtons;
